import api from 'modules/api';

export const postErrorRequest = (payload) => {
  return api.post('/error-handler/', payload);
};
